/* eslint-disable no-useless-computed-key */

import { compose } from 'recompose';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { withStyles } from '@material-ui/core';
import PropTypes from 'prop-types';
import React, { Fragment, PureComponent } from 'react';

import { setPageTitle, showToast } from 'modules/layout/layout.actions';
import Log from 'utilities/log';

import {
  getAuthClientPoliciesList,
  getAuthServices,
  getAuthorizationSummaries
} from '../authorizations/store/actions/authorizations.actions';
import {
  getBrokerAgents,
  getExpenseCodes,
  getInspectors,
  getTaxPolicies,
  getTitleReps,
  getVendorContacts,
  getVendors
} from 'modules/authorizations/store/actions/dataManagement.actions';

import { GET_VENDORS_FAILURE } from 'modules/authorizations/store/types/dataManagementTypes';

import { TOAST_MESSAGE_SEVERITY_ERROR } from '../layout/types';
import { getExpenseLineItems, getExpenseSummaries, getVoucherSummaries } from 'modules/expenses/store/expenses.actions';
import { getClients } from 'modules/clients/clients.actions';
import FullscreenSpinner from 'modules/common/fullscreenSpinner.component';
import { getAgents, getInternalUsers } from 'modules/common/common.actions';
import { GET_AGENTS_FAILURE, GET_INTERNAL_USERS_FAILURE } from 'modules/common/store/types';
import InternalUsersTable from './internalUsersTable.component';
import { getAllEnumerations } from 'modules/enumerations/store/enumerationActions';
import VendorsTableComponent from './vendorsTable.component';
import { GET_ALL_ENUMERATIONS_FAILURE } from 'modules/enumerations/store/enumeationTypes';
import AgentsTableComponent from './agentsTable.component';
import { getCommonAddress } from 'modules/common/store/common.actions';
import { GET_EXPENSE_CODES_FAILURE } from 'modules/authorizations/types';
import ExpenseCodesTable from './fileShareDataManagementFIles/expenseCodesTable.component';
import ExpenseTableComponent from './expenseTable.component';
import ClientPurposeBuiltFieldTable from './clientPurposeBuiltFieldTable.component';
import { getAllPurposeBuiltFieldTemplates } from 'modules/clients/clients.actions';
import { GET_PURPOSE_BUILT_FIELD_TEMPLATES_FAILURE } from 'modules/clients/types';
import MorrealeEquityImport from './authHomesaleEquityMorrealeImport.component';

const styles = theme => ({
  headerContainer: {
    alignItems: 'center',
    display: 'flex',
    justifyContent: 'flex-start',
    paddingLeft: theme.spacing(1),
    paddingRight: theme.spacing(1)
  },
  textField: {
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(1),
    minWidth: 100
  }
});

class ReferentialDataManagementView extends PureComponent {
  state = {
    isLoading: false
  };

  async componentDidMount() {
    this.props.setPageTitle('Referential Data Management');

    this.setState({ isLoading: true });

    if (!this.props.internalUsers) {
      let { type } = await this.props.getInternalUsers();
      if (type === GET_INTERNAL_USERS_FAILURE) {
        this.props.showToast('Failed to retrieve internal users, please try again', { severity: TOAST_MESSAGE_SEVERITY_ERROR });
      }
    }

    if (!this.props.vendors) {
      let { type } = await this.props.getVendors();
      if (type === GET_VENDORS_FAILURE) {
        this.props.showToast('Failed to retrieve vendors, please try again', { severity: TOAST_MESSAGE_SEVERITY_ERROR });
      }
    }

    if (!this.props.purposeBuiltFieldTemplates) {
      let { type } = await this.props.getAllPurposeBuiltFieldTemplates();
      if (type === GET_PURPOSE_BUILT_FIELD_TEMPLATES_FAILURE) {
        this.props.showToast('Failed to retrieve purpose built field templates, please try again', { severity: TOAST_MESSAGE_SEVERITY_ERROR });
      }
    }

    if (!this.props.expenseCodes) {
      let { type } = await this.props.getExpenseCodes();
      if (type === GET_EXPENSE_CODES_FAILURE) {
        this.props.showToast('Failed to retrieve expense codes, please try again', { severity: TOAST_MESSAGE_SEVERITY_ERROR });
      }
    }

    if (!this.props.allEnums) {
      let { type } = await this.props.getAllEnumerations();
      if (type === GET_ALL_ENUMERATIONS_FAILURE) {
        this.props.showToast('Failed to retrieve enumerations, please try again', { severity: TOAST_MESSAGE_SEVERITY_ERROR });
      }
    }

    if (!this.props.commonAddress) {
      let { type } = await this.props.getCommonAddress();
      if (type === GET_ALL_ENUMERATIONS_FAILURE) {
        this.props.showToast('Failed to retrieve common address, please try again', { severity: TOAST_MESSAGE_SEVERITY_ERROR });
      }
    }

    if (!this.props.agents) {
      let { type } = await this.props.getAgents();
      if (type === GET_AGENTS_FAILURE) {
        this.props.showToast('Failed to retrieve agents, please try again', { severity: TOAST_MESSAGE_SEVERITY_ERROR });
      }
    }

    if (!this.props.expenseSummaries) {
      await this.props.getExpenseSummaries();
    }

    if (!this.props.authorizationSummaries) {
      await this.props.getAuthorizationSummaries();
    }

    this.setState({ isLoading: false });
  }

  render() {
    Log.trace('RENDER', 'ReferentialDataManagementViw');
    return (
      <>
        <Fragment />
        {this.state.isLoading && <FullscreenSpinner />}
        {!this.state.isLoading && this.props.allEnums && (
          <div className="px-2">
            <InternalUsersTable />
            <VendorsTableComponent />
            <AgentsTableComponent />
            <ExpenseCodesTable />
            <ExpenseTableComponent expenseSummaries={this.props.expenseSummaries} authorizations={this.props.authorizationSummaries} />
            {this.props.purposeBuiltFieldTemplates && <ClientPurposeBuiltFieldTable purposeBuiltFieldTemplates={this.props.purposeBuiltFieldTemplates} />}
            <MorrealeEquityImport expenseCodes={this.props.expenseCodes} authOptions={this.props.authorizationSummaries} vendors={this.props.vendors} enumerations={this.props.allEnums} />
          </div>
        )}
      </>
    );
  }
}

ReferentialDataManagementView.propTypes = {
  setPageTitle: PropTypes.func.isRequired
};

const mapStateToProps = state => {
  const {
    authorizationSummaries,
    authorizationSummariesLoading,
    clientPolicies,
    clientPoliciesLoading,
    allServices,
    allServicesLoading,
    brokerAgentsLoading,
    brokerAgents,
    inspectors,
    isInspectorsLoading,
    titleReps,
    isTitleRepIsLoading,
    expenseCodes
  } = state.authorizations;
  const { expenseSummaries, expenseLines, voucherSummaries } = state.expenses;
  const { clients, purposeBuiltFieldTemplates } = state.clients;
  const { internalUsers, vendors, agents, commonAddress } = state.common;
  const { allEnums } = state.enumerations;

  return {
    authorizationSummaries,
    allServices,
    authorizationSummariesLoading,
    allServicesLoading,
    clientPolicies,
    clientPoliciesLoading,
    brokerAgentsLoading,
    brokerAgents,
    vendors,
    inspectors,
    isInspectorsLoading,
    titleReps,
    isTitleRepIsLoading,
    expenseCodes,
    expenseSummaries,
    expenseLines,
    voucherSummaries,
    clients,
    internalUsers,
    allEnums,
    agents,
    commonAddress,
    purposeBuiltFieldTemplates
  };
};

export default compose(
  withStyles(styles),
  withRouter,
  connect(mapStateToProps, {
    getAuthorizationSummaries,
    getAuthServices,
    setPageTitle,
    showToast,
    getAuthClientPoliciesList,
    getTaxPolicies,
    getBrokerAgents,
    getVendorContacts,
    getInspectors,
    getTitleReps,
    getExpenseCodes,
    getExpenseSummaries,
    getExpenseLines: getExpenseLineItems,
    getVoucherSummaries,
    getClients,
    getInternalUsers,
    getAllEnumerations,
    getVendors,
    getAgents,
    getCommonAddress,
    getAllPurposeBuiltFieldTemplates
  })
)(ReferentialDataManagementView);
